export default "/assets/fonts/Graphik-Bold.40a64c4ded15375976dd6ff88a8c653d.woff2";